<div class="fields-form" *ngIf="form && formReady(); else loading" [formGroup]="form">
  <h2 class="fields-form__title"> {{ 'anms.stats.date_options' | translate }} </h2>
  <div class="fields-form__row">
    <mat-form-field class="fields-form__field fields-form__field--select">
      <mat-label>{{ 'anms.stats.date_range' | translate }}</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate formControlName="startDate" placeholder="{{ 'anms.stats.start_date' | translate }}">
        <input matEndDate formControlName="endDate" placeholder="{{ 'anms.stats.end_date' | translate }}">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <mat-date-range-picker #picker></mat-date-range-picker>
  </div>
  <button mat-raised-button color="primary" *ngIf="form.value?.startDate || form.value?.endDate" (click)="onClickResetDates()">
    {{ 'anms.stats.date_range.reset' | translate }}
    <mat-icon>close</mat-icon>
  </button>

  <ng-container *ngIf="transfer.formData().type === graphType.SERIES">
    <h2 class="fields-form__title"> {{ 'anms.stats.intervals_options' | translate }} </h2>
    <div class="fields-form__row">
      <mat-form-field class="fields-form__field fields-form__field--unit">
        <mat-label>{{ 'anms.stats.interval.unit' | translate }}</mat-label>
        <mat-select formControlName="unit">
          <mat-option *ngFor="let option of unitOptions" [value]="option.value">
            {{ option.viewValue | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="fields-form__field fields-form__field--amount">
        <mat-label>{{ 'anms.stats.interval.amount' | translate }}</mat-label>
        <input matInput
              type="number"
              min="1"
              max="23"
              formControlName="amount">
      </mat-form-field>
    </div>
  </ng-container>

  <h2 class="fields-form__title"> {{ 'anms.stats.filter_options' | translate }} </h2>
  <mat-accordion class="fields-form__grid" formGroupName="filter" [multi]="true">
    <ng-container *ngFor="let controlName of transfer.formData().controlNames">
    <ng-container *ngVar="transfer.info()[controlName] as info">
    <ng-container [ngSwitch]="info.type">

      <mat-expansion-panel class="mat-elevation-z0 fields-form-selection" *ngSwitchCase="'select'">
        <mat-expansion-panel-header>
          <mat-panel-title>

            {{ info.viewValue | translate}}
            <ng-container *ngIf="info.help">
                <mat-icon class="fields-form__icon" [matMenuTriggerFor]="regexHelpMenu" (click)="$event.stopPropagation()">help</mat-icon>
                <mat-menu #regexHelpMenu="matMenu" yPosition="above">
                  <div class="fields-form-menu">{{info.help | translate}}</div>
                </mat-menu>
            </ng-container>

          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-selection-list [formControlName]="controlName" class="mat-density--3" *ngIf="info.values?.length">
            <mat-list-option *ngFor="let option of info.values"
                              [value]="option"
                              color="primary">
              <ng-container *ngIf="viewValues[option]; else raw">
                {{ viewValues[option] | translate }}
              </ng-container>
              <ng-template #raw>{{ option }}</ng-template>
            </mat-list-option>
        </mat-selection-list>

      </mat-expansion-panel>

      <div class="fields-form-checkbox" *ngSwitchCase="'checkbox'">
        <mat-checkbox (click)="onClickCheckbox(controlName)"
                      [checked]="!!form.value.filter?.[controlName]"
                      color="primary"
                      [indeterminate]="form.value.filter?.[controlName] === null">
          {{ info.viewValue | translate }}
        </mat-checkbox>
        <ng-container *ngIf="info.help">
            <mat-icon class="fields-form__icon" [matMenuTriggerFor]="regexHelpMenu" (click)="$event.stopPropagation()">help</mat-icon>
            <mat-menu #regexHelpMenu="matMenu" yPosition="above">
              <div class="fields-form-menu">{{info.help | translate}}</div>
            </mat-menu>
        </ng-container>
      </div>

      <div class="series-error" *ngSwitchDefault>
      </div>

    </ng-container>
    </ng-container>
    </ng-container>
  </mat-accordion>

  <h2 class="fields-form__title"> {{ 'anms.stats.select_options' | translate }} </h2>
  <div class="fields-form__grid">
    <mat-form-field class="fields-form__field fields-form__field--select">
      <mat-label>{{ 'anms.stats.select_options' | translate }}</mat-label>
      <mat-select formControlName="group">
        <mat-option *ngFor="let option of transfer.formData().groupOptions" [value]="option.field">
          {{ option.viewValue | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <h2 class="fields-form__title"> {{ 'anms.stats.value_options' | translate }} </h2>
  <div class="fields-form__row">
    <mat-form-field class="fields-form__field fields-form__field--select">
      <mat-label>{{ 'anms.stats.value_options' | translate }}</mat-label>
      <mat-select formControlName="value">
        <mat-option *ngFor="let option of transfer.formData().valueOptions" [value]="option.field">
          {{ option.viewValue | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="fields-form__field fields-form__field--select" *ngIf="aggFunctionOptions().length > 1">
      <mat-label>{{ 'anms.stats.agg_function' | translate }}</mat-label>
      <mat-select formControlName="aggFunction">
        <mat-option *ngFor="let option of aggFunctionOptions()" [value]="option">
          {{ option | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>


  <div class="fields-form__footer" *ngIf="form.dirty">
    <button class="" mat-raised-button color="primary" [disabled]="!form.dirty || form.invalid" (click)="onSaveForm()">
      <mat-icon>done</mat-icon>
      {{ 'anms.stats.save' | translate }}
    </button>

    <button class="" mat-button color="warn" [disabled]="!form.dirty" (click)="onResetForm()">
      {{ 'anms.stats.cancel' | translate }}
    </button>
  </div>
</div>

<ng-template #loading>
  <div class="fields-spinner">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
